<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <v-layout row wrap>
            <v-flex lg12 pl-5>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#3480c1" dark v-bind="attrs" v-on="on">
                    {{getStatusName(selectedStatus)}} <v-icon right dark>arrow_drop_down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="filterClick(-1)">
                    <v-list-item-title>{{getStatusName(-1)}}</v-list-item-title>
                    <v-list-item-icon>
                      <v-badge color="#3480c1" overlap class="mt-1">
                        <span slot="badge">{{getTotalOrder(-1)}}</span>
                      </v-badge>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-divider></v-divider>
                  <template v-for="(item, index) in listStatus">
                    <v-list-item :key="item.value" @click="filterClick(item.value)">
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                      <v-list-item-icon>
                        <v-badge color="#3480c1" overlap class="mt-1">
                          <span slot="badge">{{getTotalOrder(item.value)}}</span>
                        </v-badge>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-divider :key="'divider-' + item.value" v-if="index < listStatus.length - 1"></v-divider>
                  </template>
                </v-list>
              </v-menu>
              <v-btn class="ml-3" color="#3480c1" :dark="selectedOrders.length > 0" :disabled="selectedOrders.length == 0">Thanh toán</v-btn>
            </v-flex>
          </v-layout>
          <hpo-filter :headers="filterColumns" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-widget title="Thống kê chi phí" v-if="selectedOrders.length > 0">
              <div slot="widget-content">
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Số đơn hàng:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.length}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Tổng tiền:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Đã cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Cần cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.MinDeposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Còn thiếu:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{(selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) - selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0)) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
              </div>
          </v-widget>
          <v-data-table
            :headers="headers"
            :items="orders"
            :must-sort="true"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :loading="loading"
            show-select
            :mobile-breakpoint="100"
            v-model="selectedOrders"
            item-key="ID"
            class="elevation-1"
          >
            <template v-slot:item="{ item, isSelected, select}">
              <tr :active="isSelected">
                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                <td class="truncate">
                  {{ item.CustomerName }}
                  <v-divider></v-divider>
                  {{ item.Email }}
                  <v-divider></v-divider>
                  {{ item.PhoneNumber }}
                </td>
                <td><a @click="gotoDetail(item.ID)">{{ item.ID }}</a></td>
                <td>
                  <v-tooltip color='#3480c1' right v-if="item.ChangedHistories && item.ChangedHistories.length > 0">
                    <template v-slot:activator="{ on }">
                      <v-chip :color="get_order_status_color(item.Status)" v-on="on" label outlined small> {{ item.Status | order_status}}</v-chip>
                    </template>
                    <span>
                      <v-list color="transparent" width="350">
                          <template v-for="(h_item, index) in item.ChangedHistories" >
                              <v-list-item v-bind:key="index" dark>
                                  <v-list-item-title>{{h_item.HistoryContent}}</v-list-item-title>
                                  <v-list-item-subtitle>{{h_item.CreatedDate | display_date}}</v-list-item-subtitle>
                              </v-list-item>
                          </template>
                      </v-list>
                    </span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                      <template v-slot:activator="{ on }">
                        <v-chip :color="get_order_status_color(item.Status)" v-on="on" label outlined small> {{ item.Status | order_status}}</v-chip>
                      </template>
                      <span>{{ item.Status | order_status}}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-img :src="proxyImage(item.image_origin && item.image_origin.includes('firebase') ? item.image_origin : decodeURIComponent(item.image_origin))" width="64px" height="64px"></v-img>
                </td>
                <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                <td v-if="orderRole & 512">
                  <v-edit-dialog
                    :return-value.sync="item.BuyerName"
                    large
                    lazy
                    persistent
                    @save="saveStaff(item.ID, item.BuyerID, item.CSID)"
                  >
                    <div>{{ item.BuyerName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="p_staffs"
                        v-model="item.BuyerID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.BuyerName = getStaffName(item.BuyerID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!(orderRole & 512)">
                  {{ item.BuyerName }}
                </td>
                <td v-if="(orderRole & 1024)">
                  <v-edit-dialog
                    :return-value.sync="item.CSName"
                    large
                    lazy
                    persistent
                    @save="saveStaff(item.ID, item.BuyerID, item.CSID)"
                  >
                    <div>{{ item.CSName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="cs_staffs"
                        v-model="item.CSID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.CSName = getStaffName(item.CSID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!(orderRole & 1024)">
                  {{ item.CSName }}
                </td>
                <td>
                  Lên đơn: {{ item.CreatedDate | display_date }}
                  <br />
                  Mua hàng: {{ item.BoughtDate | display_date }}
                  <br />
                  Hoàn thành: {{ item.CompletedDate | display_date }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogDeposit" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Phân bổ tiền cọc</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <h-currency-input label="Tổng tiền cọc (₫)" v-model="totalDeposit" :decimal="0"></h-currency-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogDeposit = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="depositBlance">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.Products" :key="item.ID">
                    <v-list-item-content>
                      <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <!-- <v-text-field label="Link ảnh" v-model="item.Image"></v-text-field> -->
                      <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="`${getImages(index)}`" ref="imageFile"/>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-text-field label="Thuộc tính" v-model="item.Property"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="item.Price"></h-currency-input>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                    </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.Products.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link ảnh" v-model="newProduct.Image"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                        <div class="row">
                            <div class="col-md-4">
                                <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image" ref="imageFile"/>
                            </div>
                            <div class="col-md-8">
                                <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                                <button @click="chooseImage(newProduct)" style="cursor: point">Tải ảnh</button>
                            </div>
                        </div>
                    </div>
                  </v-flex>
                  <v-flex lg3 md3 sm12>
                    <v-text-field label="Thuộc tính" v-model="newProduct.Property"></v-text-field>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="newProduct.Price"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VWidget from "@/components/VWidget";
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, makeid, proxyImage } from "@/commons/utils";
import firebase from 'firebase';
export default {
  components: {
    VWidget,
    "hpo-filter": Filtering
  },
  data() {
    return {
      proxyImage: proxyImage,
      imageData: null,
      hideImage: false,
      search: "",
      selectedStatus: -1,
      selectedOrders: [],
      headers: [
        {
          text: "Khách hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },       
        {
          text: "Order ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.ORDER_STATUS
        },
        {
          text: "Ảnh SP",
          value: "image_origin",
          sortable: false,
          filterable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mua hàng",
          value: "BuyerName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "CSKH",
          value: "CSName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Ngày",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        }
      ],
      pagination: {
        ...configs.PAGINATION,
        sortBy: ["ID"]
      },
      selectedTab: 0,
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      listStatus: configs.ORDER_STATUS,
      viewName: "order_list",
      filterConditions: [],
      quickFilterConditions: [],
      dialogDeposit: false,
      totalDeposit: 0,
      dialogNew: false,
      newProduct: {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      },
      newOrder: {
        UID: 0,
        Products: []
      }
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    orders: function(val) {
      this.selectedOrders = [];
    },
    selectedStatus() {
      this.filter_data();
    }
  },
  computed: {
    ...mapState({
      orders: state => state.main_order.all.data,
      orderSummary: state => state.main_order.all.summary,
      total_rows: state => state.main_order.all.total,
      loading: state => state.main_order.loading,
      staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
        }),
      p_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        }),
      cs_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        }),
      customers: state => state.customer.master.data
    }),
    pages() {
      return Math.ceil(
        this.total_rows / this.options.itemsPerPage
      );
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    orderRole() {
      return this.$store.state.authentication.role.Orders;
    },
    filterColumns() {
      let fc = [...this.headers];
      fc.push({
          text: "Email",
          value: "Email",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        });
      fc.push({
          text: "Điện thoại",
          value: "PhoneNumber",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        })
      return fc;
    }
  },
  methods: {
    filterClick(status) {
      this.selectedStatus = status;
      _.remove(this.filterConditions, {column: "Status"});
      if(status != -1) {
        this.filterConditions.push({
          column: "Status",
          value: this.selectedStatus,
          condition: "equal"
        });
      }
    },
    getTotalOrder(status, format = true) {
      var total = 0;
      if(!this.orderSummary) {
          return 0;
      }
      switch (status) {
          case 0:
              total = this.orderSummary.TotalStatus0;
              break;
          case 1:
              total = this.orderSummary.TotalStatus1;
              break;
          case 2:
              total = this.orderSummary.TotalStatus2;
              break;
            case 3:
              total = this.orderSummary.TotalStatus3;
              break;
          case 5:
              total = this.orderSummary.TotalStatus5;
              break;
          case 6:
              total = this.orderSummary.TotalStatus6;
              break;
          case 7:
              total = this.orderSummary.TotalStatus7;
              break;
          case 8:
              total = this.orderSummary.TotalStatus8;
              break;
          case 9:
              total = this.orderSummary.TotalStatus9;
              break;
          case 10:
              total = this.orderSummary.TotalStatus10;
              break;
          case 11:
              total = this.orderSummary.TotalStatus11;
              break;
          case 12:
              total = this.orderSummary.TotalStatus12;
              break;
          case 13:
              total = this.orderSummary.TotalStatus13;
              break;
          case 16:
              total = this.orderSummary.TotalStatus16;
              break;
          default:
              total = this.orderSummary.TotalStatusAll;
              break;
      }

      if(total < 999 || !format) {
          return total.toLocaleString('en-US');
      }
      return (Math.floor(total / 1000, 0)).toLocaleString('en-US') + 'K';
    },
    getStatusName(status) {
      if(status == -1) {
        return 'Tất cả đơn hàng';
      }
      const item = _.find(this.listStatus, {value: status});
      return item ? item.name : ''
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("main_order/getListOrders", param);
      this.getCustomerList();
    },
    gotoDetail: function(id) {
      let routeData = this.$router.resolve({
        name: "OrderDetail",
        params: {
          Pid: id,
          title: `Chi tiết đơn hàng (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    saveStaff(orderId, buyerId, csId) {
      const updateInfo = {
        OrderID: orderId,
        CustomerServiceID: csId,
        BuyerID: buyerId
      };
      this.$store.dispatch("main_order/updateOrderDetail", updateInfo);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    },
    depositDialog() {
      if(!this.adminRole && !this.paymentRole) {
        sendErrorNotice("Bạn không có quyền thực hiện chức năng này!");
        return;
      }
      if(this.selectedOrders.length == 0) {
        sendErrorNotice("Hãy chọn các đơn muốn phân bổ!");
        return;
      }
      this.dialogDeposit = true;
    },
    depositBlance() {
      if(this.totalDeposit <= 0) {
        sendErrorNotice("Hãy nhập tổng tiền cọc muốn phân bổ!");
        return;
      }
      var needDepositOrder = _.filter(this.selectedOrders, {'Status': configs.ORDER_STATUS_ENUM.cho_dat_coc});
      var ids = _.map(needDepositOrder, 'ID');
      var currentNeedDeposit = needDepositOrder.map(item => item.MinDeposit).reduce((prev, curr) => prev + curr, 0);
      var blance = this.totalDeposit - currentNeedDeposit;
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("main_order/depositBlance", {'ids': ids, 'totalDeposit': blance, 'param': param});
      this.dialogDeposit = false;
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "BuyerID", "CustomerServiceID", "ReceivePlaceID"]
      });
    },
    appendProduct() {
      this.newOrder.Products.push(this.newProduct);
      this.newProduct = {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      }
    },
    createData() {
      this.dialogNew = true;
    },
    createNewOrder() {
      if(this.newOrder.Products.length == 0) {
        sendErrorNotice("Hãy nhập danh sách sản phẩm!");
        return;
      }
      if(this.newOrder.UID == 0) {
        sendErrorNotice("Hãy chọn khách hàng!");
        return;
      }
      const cust = _.find(this.customers, {'ID': this.newOrder.UID});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.newOrder.Username = cust.Username;
      this.newOrder.BuyerID = cust.BuyerID;
      this.newOrder.CustomerServiceID = cust.CustomerServiceID;
      this.newOrder.ReceivePlaceID = cust.ReceivePlaceID;

      this.$store.dispatch("main_order/createNew", {'data': this.newOrder, 'param': param});
      this.newOrder = {
        UID: 0,
        Products: []
      };
      this.dialogNew = false;
      sendSuccessNotice('Tạo mới đơn hàng thành công.');
    },
    chooseImage(item) {
        this.newProduct.Image = '';
        this.$refs.fileInput.click();
    },
    previewImage(event) {
        this.imageData = event.target.files[0];
        this.$refs.fileInput.value = null;
        this.onUpload()
    },
    onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                
            },
            error => {
              sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
            },
            () => {
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.newProduct.Image =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    },
    getImages(index) {
        return this.newOrder.Products[index].Image;
    }
  },
  created() {
    this.$store.dispatch("commons/getAllUsers");
  },
  mounted() {
    this.filterConditions = [];
    this.quickFilterConditions = [];
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_SAVE_DATA", this.depositDialog);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_SAVE_DATA", this.depositDialog);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
<style lang="stylus" scoped>
.image-product {
  width: 64px;
  height: 64px;
}
</style>